import { DocumentNode } from 'graphql'
import { gql } from 'graphql-tag'

import {
  NetworkPublicInfoFields,
  networkPublicInfoGQLFields,
} from './networkPublicInfo.fields.js'

export function getWorkspacesGQLQuery(
  fields: NetworkPublicInfoFields,
): DocumentNode {
  return gql`
    query Workspaces {
      workspaces {
        ${networkPublicInfoGQLFields(fields)}
      }
    }
  `
}
